var SDK_VERSION = '7.12.1';

export { SDK_VERSION };
